import { render, staticRenderFns } from "./ResetPwdShopWindow.vue?vue&type=template&id=09a13ef2&scoped=true&"
import script from "./ResetPwdShopWindow.vue?vue&type=script&lang=js&"
export * from "./ResetPwdShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdShopWindow.vue?vue&type=style&index=0&id=09a13ef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a13ef2",
  null
  
)

export default component.exports